import React, {FC, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {addressService} from "../../../store/actions";
import ContractMethodItem from "./contract-method-item";
import useCommon from "../../../common/hooks/useCommon";
import {useTranslation} from "react-i18next";
// import MetaMaskButton from "../metamask";
import WalletInfo from "../metamask/support-files/contractConnectedWallet";

interface AbiItem {
    name: string;
    method_id: string;
    inputs: any[];
    stateMutability: string;
    outputs: any[];
    type: string;
}

interface ReadWriteContractProps {
    isRead: boolean;
    isProxy: boolean;
    metamaskAddress?: string;
    validChainId?: boolean;
    implementation?: any;
}

const ReadWriteContract: FC<ReadWriteContractProps> = (props) => {
    const {get0x} = useCommon();
    const {address, token} = useParams();
    const [abi, setABI] = useState<[]>([]);
    const [loading, setLoading] = useState(true);
    const {t, i18n} = useTranslation();
    const [allExpanded, setAllExpanded] = useState(false);
    const [connectionStatus, setConnectionStatus] = useState<string>('');
    const [account, setAccount] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    const getPrice = async () => {
        try {
            setLoading(true);
            const path = props?.isProxy
                ? props?.isRead
                    ? "/methods-read-proxy?is_custom_abi=false"
                    : "/methods-write-proxy?is_custom_abi=false"
                : props?.isRead
                    ? "/methods-read?is_custom_abi=false"
                    : "/methods-write?is_custom_abi=false";
            // addressService.getVerifiedAddress(props?.isProxy ? props?.implementation : (address || token), path).then(response => {
            addressService
                .getVerifiedAddress(address || token, path)
                .then((response) => {
                    if (!props?.isRead) {
                        response = response?.filter(
                            (a: any) =>
                                (a.stateMutability !== "view" &&
                                    !!a.name &&
                                    a.type === "function") ||
                                (a.stateMutability !== "view" && a.type === "fallback")
                        );
                    }
                    if (!response?.error) {
                        setABI(response || []);
                    }
                    setLoading(false);
                })
                .catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getPrice();
    }, [props?.isRead, props?.isProxy]);

    const handleExpandAll = () => {
        setAllExpanded(!allExpanded);
    };

    const handleReset = () => {
        setAllExpanded(false);
    }
    return (
        <div className="py-3">
            <div className="row">
                {props?.isProxy && props?.implementation && (
                    <div className="col-lg-12">
                        <div className="bs-list">
                            <div className="bs-list-row">
                                {t("ABI for the implementation contract at")}:&nbsp;
                                <Link to={`/address/${get0x(props?.implementation)}`}>
                                    {props?.implementation}
                                </Link>
                            </div>
                        </div>
                    </div>
                )}
                <div className="col-lg-12">
                    <WalletInfo/>
                    <div className="d-flex justify-content-between mb-3">
                        <p className="ms-1 me-3 mb-1">
                            <i className="bi bi-file-earmark-text me-1"> Read Contract Information </i>
                        </p>
                        <span>
                            <a href="#" className="me-1" onClick={handleExpandAll}>
                                {allExpanded ? "[Collapse All]" : "[Expand All]"}
                            </a>
                            <a href="#" className="me-1" onClick={handleReset}>
                                [Reset]
                            </a>
                        </span>
                    </div>
                    <div className="accordion">
                        {abi?.map((data: AbiItem, i: number) => {
                            return (
                                <ContractMethodItem
                                    key={i}
                                    data={data}
                                    index={i}
                                    metamaskAddress={account || " "}
                                    isRead={props.isRead}
                                    allExpanded={allExpanded}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReadWriteContract;
